import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import {
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Icon,
  Popover,
  Image,
  Pagination,
  Select,
  Input,
  Option,
  DatePicker,
  Dialog,
  Empty,
  Table,
  TableColumn,
  Skeleton,
  SkeletonItem,
  Loading,
  Message,
} from 'element-ui';

/* 走马灯 */
Vue.use(Carousel);
Vue.use(CarouselItem);

/* 折叠面板 */
Vue.use(Collapse);
Vue.use(CollapseItem);

/* 图标 */
Vue.use(Icon);

/* 图片 */
Vue.use(Image);

/* 弹出框 */
Vue.use(Popover);

/* 分页 */
Vue.use(Pagination)

Vue.use(Input)
Vue.use(Select)
Vue.use(Option)

Vue.use(DatePicker)

Vue.use(Dialog)

Vue.use(Empty)

Vue.use(Table)
Vue.use(TableColumn)

Vue.use(Skeleton)
Vue.use(SkeletonItem)

Vue.use(Loading.directive);

/* 消息提示 */
Vue.prototype.$message = Message;

Vue.prototype.$loading = Loading.service;
